import React from "react";

const Pagination = ({ pages, currentPage, prePage, nextPage, changePage, nPage }) => {
  return (
    <div className="flex items-center">
      <button
        onClick={prePage}
        disabled={currentPage===1}
        className="mx-1 text-sm font-semibold text-gray-900"
      >
        &larr; Previous
      </button>
      {pages.map((page) => (
        <button
          key={page}
          onClick={() => changePage(page)}
          className={`mx-1 flex items-center rounded-md border border-gray-400 px-3 py-1 text-gray-900 hover:scale-105 ${
            currentPage === page ? "bg-sky-100" : "bg-transparent"
          }`}
        >
          {page}
        </button>
      ))}
      <button
        onClick={nextPage}
        disabled={currentPage===nPage}
        className="mx-2 text-sm font-semibold text-gray-900"
      >
        Next &rarr;
      </button>
    </div>
  );
};

export default Pagination;
